<div class="idp-label-with-text-container">
  <div
    class="section-terms-text"
    [ngStyle]="styles"
    [innerHTML]="description"
  ></div>
  <div class="section-link">
    <idp-link
      (clicked)="notify($event)"
      [label]="linkLabel"
      [labelSize]="labelSize"
      [axLabel]="linkLabel"
    ></idp-link>
  </div>
</div>
